import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ClientConfigService } from '../services/client-config.service';

@Component({
  template: ''
})
export abstract class BaseErrorPageComponent {
  protected router = inject(Router);
  public clientConfigService = inject(ClientConfigService);

  get supportPhone(): string {
    return this.clientConfigService.getSupportPhone();
  }

  get supportLink(): string {
    return this.clientConfigService.getSupportLink();
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
